import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "collapse"]
  static values = {
    url: String,
    loaded: { type: Boolean, default: false }
  }

  connect() {
    this.onShow = this.loadRows.bind(this)
    const $ = window.jQuery || window.$
    if ($ && this.hasCollapseTarget) {
      $(this.collapseTarget).on("shown.bs.collapse", this.onShow)
    } else if (this.hasCollapseTarget) {
      this.collapseTarget.addEventListener("shown.bs.collapse", this.onShow)
    }
  }

  disconnect() {
    const $ = window.jQuery || window.$
    if ($ && this.hasCollapseTarget) {
      $(this.collapseTarget).off("shown.bs.collapse", this.onShow)
    } else if (this.hasCollapseTarget) {
      this.collapseTarget.removeEventListener("shown.bs.collapse", this.onShow)
    }
  }

  loadRows() {
    if (this.loadedValue || !this.hasUrlValue || !this.hasListTarget) {
      return
    }

    this.loadedValue = true

    const placeholder = this.listTarget.querySelector(".field-ratings-residency-section__rows-placeholder")
    if (placeholder) {
      placeholder.innerHTML = '<small class="text-muted">Loading field calls...</small>'
    }

    fetch(this.urlValue, {
      headers: {
        Accept: "text/html",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin"
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load field calls (${response.status})`)
        }
        return response.text()
      })
      .then((html) => {
        const current = this.listTarget.querySelector(".field-ratings-residency-section__rows-placeholder")
        if (current) {
          current.remove()
        }
        this.listTarget.insertAdjacentHTML("beforeend", html)
      })
      .catch(() => {
        this.loadedValue = false
        const current = this.listTarget.querySelector(".field-ratings-residency-section__rows-placeholder")
        if (current) {
          current.innerHTML = '<small class="text-danger">Unable to load field calls. Please try again.</small>'
        }
      })
  }
}
